import { render, staticRenderFns } from "./ZdHome.vue?vue&type=template&id=36f6e95e&scoped=true&"
import script from "./ZdHome.vue?vue&type=script&lang=js&"
export * from "./ZdHome.vue?vue&type=script&lang=js&"
import style0 from "./ZdHome.vue?vue&type=style&index=0&id=36f6e95e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f6e95e",
  null
  
)

export default component.exports